// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog_blog__3AtwA","blogPosts":"blog_blogPosts__2nQ-c","userAva":"blog_userAva__8wkGH","data":"blog_data__3s6as","inputForm":"blog_inputForm__26FzV"};